// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    home: path(ROOTS_DASHBOARD, "/home"),
    pilot: path(ROOTS_DASHBOARD, "/pilot"),
    clone: path(ROOTS_DASHBOARD, "/clone"),
    backfill: path(ROOTS_DASHBOARD, "/backfill"),
    safeBackfill: path(ROOTS_DASHBOARD, "/safe-backfill"),
    user: {
        root: path(ROOTS_DASHBOARD, "/user"),
        item: path(ROOTS_DASHBOARD, "/user/:sub"),
    },
    data: {
        weight: path(ROOTS_DASHBOARD, "/data/weight"),
        meal: path(ROOTS_DASHBOARD, "/data/meal"),
        checkin: path(ROOTS_DASHBOARD, "/data/checkin"),
    },
    feedback: path(ROOTS_DASHBOARD, "/feedback"),
    links: path(ROOTS_DASHBOARD, "/links"),
    controlFlags: path(ROOTS_DASHBOARD, "/control-flags"),
    bulkEmailToUserId: path(ROOTS_DASHBOARD, "/bulk-email-to-user-id"),
    addToActivationDebug: path(ROOTS_DASHBOARD, "/add-to-activation-debug"),
    betaGroup: path(ROOTS_DASHBOARD, "/beta-group"),
    addToPilot: path(ROOTS_DASHBOARD, "/add-to-pilot"),
    checkIn: path(ROOTS_DASHBOARD, "/check-in"),
};
